import {
  Card,
  CardContent,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import React, { useCallback, useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";

import DataGrid from "../../shared/components/DataGrid/DataGrid";

import { useLocation, useNavigate } from "react-router-dom";
import {
  leaveTypesArray,
  rowPerPage,
  timesheetPeriods,
  timesheetStatusArray,
} from "../../Constants";

import _ from "lodash";
import {
  MenuOptions,
  Option,
} from "../../shared/components/CommonFilters/CommonFilterMenu";
import Header from "../../shared/components/CommonPageHeader/Header";
import MobileSkeleton from "../../shared/components/Skeletons/MobileSkeleton";
import TableSkeleton from "../../shared/components/Skeletons/TableSkeleton";
import { usePermissions } from "../../utils/permission";
import {
  Columns,
  copyToClicpBoard,
  getTimesheetList,
  timesheetRow,
} from "./Timesheet.helper";
import TimesheetListMobile from "./TimesheetListMobile";

type ApprovalsProps = {
  getUsersType?: string;
  staticCompany?: string;
  back?: (boolean) => void;
};

const MENU_OPTIONS: Array<MenuOptions> = [
  {
    id: "status",
    title: "Status",
    options: timesheetStatusArray.map((el) => ({
      id: el,
      title: el,
    })),
  },
  {
    id: "period",
    title: "Period",
    options: timesheetPeriods.map((el) => ({
      id: el,
      title: el,
    })),
  },
];

const Timesheet: React.FunctionComponent<ApprovalsProps> = (props) => {
  const alert = useAlert();
  const location: any = useLocation();
  const { dashboardFilter = "" } = location?.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(`(max-width: 760px)`);
  const skeleton = isMobile ? <MobileSkeleton /> : <TableSkeleton />;
  const { Timesheet_ListView } = usePermissions();
  const [searched, setSearched] = useState("");

  const [currentView, setCurrentView] = useState("list");
  const [anchorEditColumnEl, setAnchorEditColumnEl] =
    React.useState<null | HTMLElement>(null);
  const openEditCoulmn = Boolean(anchorEditColumnEl);
  const handleEditColumnClose = () => {
    setAnchorEditColumnEl(null);
  };

  const [leaveType, setLeaveType] = React.useState<string[]>(leaveTypesArray);

  const [leaveStatus, setLeaveStatus] = React.useState<string>("All");

  const {
    isTimesheetListLoading,
    timesheetList,
    timesheetListError,
    isPaging,
    page,
    timesheetPageSize,
    timesheetCurrentPage,
  } = useSelector(
    //@ts-ignore
    (state) => state.timesheet,
  );

  useEffect(() => {
    if (!_.isEmpty(dashboardFilter)) {
      let payload = {
        load: 0,
        timesheetApprovalStatus: ["approved"],
        period: "All",
        pageSize: timesheetPageSize ? timesheetPageSize : rowPerPage,
        isDesc: false,
      };

      if (dashboardFilter === "Pending") {
        payload = {
          ...payload,
          timesheetApprovalStatus: ["Pending"],
        };
      }

      getTimesheetList(dispatch, payload);
    }
  }, [dashboardFilter, dispatch, timesheetPageSize]);

  useEffect(() => {
    const payload = { load: 0 };
    getTimesheetList(dispatch, payload);

    return () => {
      setMobileUserList([]);
    };
  }, [dispatch]);

  //mobile
  const [Showfloat, setShowfloat] = React.useState<boolean>(false);
  const [mobileUserList, setMobileUserList] = React.useState<any>([]);
  const [mobilePageLoad, setMobilePageLoad] = React.useState<number>(1);

  useEffect(() => {
    if (mobilePageLoad === 1) {
      setMobileUserList(timesheetList);
    } else {
      const newList = [...mobileUserList, ...timesheetList];
      setMobileUserList(newList);
    }
  }, [timesheetList]);

  const [filters, setFilters] = useState<Option>({});

  const setFilterObject = useCallback((option: Option) => {
    setFilters((prev) => ({
      ...prev,
      ...option,
    }));
  }, []);

  const loadList = useCallback(() => {
    const payload = {
      load: 0,
      timesheetApprovalStatus: filters.status,
      period: filters.period,
      pageSize: timesheetPageSize ? timesheetPageSize : rowPerPage,
      searchValue: searched,
      pageNumber: 1,
    };
    getTimesheetList(dispatch, payload);
  }, [dispatch, filters, searched, timesheetPageSize]);

  useEffect(() => {
    loadList();
  }, [filters, loadList]);

  return (
    <>
      <Grid container component="main">
        <Container maxWidth="xl">
          {/* Search Bar Header */}

          <>
            <Header
              options={MENU_OPTIONS}
              filters={filters}
              setFilters={setFilterObject}
              onSearch={setSearched}
            />

            <Box mt={1} mb={1}>
              <Card>
                <CardContent>
                  {isTimesheetListLoading ? (
                    skeleton
                  ) : isMobile ? (
                    <Box sx={{ mt: 2 }}>
                      <TimesheetListMobile
                        listData={timesheetRow(mobileUserList)}
                        totalPageCount={2}
                        onLoadmore={loadList}
                        currentPage={1}
                        isLoading={false}
                      />
                    </Box>
                  ) : (
                    Timesheet_ListView && (
                      <DataGrid
                        header={Columns}
                        row={timesheetRow(timesheetList)}
                        getDetails={(id) => {
                          console.log(id, "++++id");
                          navigate(`/timesheets/timesheet-details/${id}`);
                        }}
                        showPaging={isPaging}
                        page={page}
                        defaultRowPerPageCount={timesheetPageSize}
                        currentPage={timesheetCurrentPage}
                        rowPerPage={(row) => {
                          const payload = {
                            load: 0,
                            timesheetApprovalStatus: filters.status,
                            period: filters.period,
                            pageSize: row,
                            searchValue: searched,
                          };
                          getTimesheetList(dispatch, payload);
                        }}
                        getPageList={(page) => {
                          const payload = {
                            load: 0,
                            pageNumber: page,
                            timesheetApprovalStatus: filters.status,
                            period: filters.period,
                            pageSize: timesheetPageSize,
                            searchValue: searched,
                          };
                          getTimesheetList(dispatch, payload);
                          setMobileUserList([]);
                        }}
                        sortTable={(sort, key) => {
                          const payload = {
                            load: 0,
                            isDesc: sort,
                            columnName: key,
                            timesheetApprovalStatus: filters.status,
                            period: filters.period,
                            pageSize: timesheetPageSize,
                            searchValue: searched,
                          };
                          getTimesheetList(dispatch, payload);
                          setMobileUserList([]);
                        }}
                        search={(value) => {
                          const payload = {
                            timesheetApprovalStatus: filters.status,
                            period: filters.period,
                            pageSize: timesheetPageSize,
                            searchValue: value,
                          };
                          getTimesheetList(dispatch, payload);
                          setMobileUserList([]);
                        }}
                      />
                    )
                  )}
                </CardContent>
              </Card>
            </Box>
          </>

          <Menu
            id="menu"
            anchorEl={anchorEditColumnEl}
            keepMounted
            open={openEditCoulmn}
            onClose={handleEditColumnClose}
            onClick={handleEditColumnClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 15,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              disabled={currentView === "calendar"}
              onClick={() => {
                setCurrentView("calendar");
              }}
            >
              Calendar View
            </MenuItem>
            <MenuItem
              disabled={currentView === "list"}
              onClick={() => {
                setCurrentView("list");
                getTimesheetList(dispatch, {
                  load: 0,
                  leaveTypeList: leaveType,
                  timesheetApprovalStatus: leaveStatus,
                });
              }}
            >
              List View
            </MenuItem>
            <MenuItem
              onClick={() => {
                copyToClicpBoard(alert);
              }}
            >
              Share Calendar
            </MenuItem>
          </Menu>
        </Container>
      </Grid>
    </>
  );
};

export default Timesheet;
